import { render, staticRenderFns } from "./RegisterYoung.vue?vue&type=template&id=fc0d584c&lang=pug"
import script from "./RegisterYoung.vue?vue&type=script&lang=js"
export * from "./RegisterYoung.vue?vue&type=script&lang=js"
import style0 from "./RegisterYoung.vue?vue&type=style&index=0&id=fc0d584c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports